import { setListenersFromSelector } from '../functions/listeners';
import { querySelector, querySelectorId } from '../functions/querySelectors';
import { lugisbox } from './lugisbox';

const OPENER_CLASS = 'js-search-open';
const OPENER_INIT_CLASS = 'jso-init';
const CLOSER_CLASS = 'js-search-close';
const CLOSER_INIT_CLASS = 'jsc-init';
const SEARCH_CLASS = 'c-header-search';
const SEARCH_OPEN_CLASS = 'c-header-search--open';
const BLUR_CLASS = 'blur-search';
const SEARCH_INPUT_ID = 'searchText';

let getSearch = function() {
  return querySelector(`.${SEARCH_CLASS}`);
};

let openerClick = function(event) {
  event.preventDefault();
  getSearch().classList.add(SEARCH_OPEN_CLASS);
  document.body.classList.add(BLUR_CLASS);
  querySelectorId(SEARCH_INPUT_ID).focus();
  lugisbox();
};

let closerClick = function(event) {
  event.preventDefault();
  getSearch().classList.remove(SEARCH_OPEN_CLASS);
  document.body.classList.remove(BLUR_CLASS);
};

let setOpener = function() {
  setListenersFromSelector(
    `.${OPENER_CLASS}`,
    OPENER_INIT_CLASS,
    openerClick
  );
};

let setCloser = function() {
  setListenersFromSelector(
    `.${CLOSER_CLASS}`,
    CLOSER_INIT_CLASS,
    closerClick
  );
};

export default function() {
  setOpener();
  setCloser();
};
